module.exports = __webpack_public_path__ + "img/raxx-on-raxx.c68b5066.png";